import {
  postEventRequest,
  getAllEventRequest,
  getEventByIdRequest,
  updateEventRequest,
  deleteEventRequest,
} from "../repositories/event_respository";

export const EventService = () => {
  const fetchAllEvents = async (setEventList) => {
    try {
      const response = await getAllEventRequest();
      if (response?.success) {
        setEventList(response.data);
      } else {
        console.error("Failed to fetch events:", response?.errors);
      }
    } catch (error) {
      console.error("Failed to fetch event data:", error);
    }
  };

  const fetchEventById = async (id) => {
    try {
      const response = await getEventByIdRequest(id);
      if (response?.success) {
        return response.data;
      } else {
        console.error("Failed to fetch event details:", response?.errors);
        throw new Error(response?.errors || "Failed to fetch event details");
      }
    } catch (error) {
      console.error("Error in fetchEventById:", error);
      throw error;
    }
  };

  const createEvent = async (eventDetails, setEventList, setErrors) => {
    try {
      const response = await postEventRequest(eventDetails);
      if (response?.success) {
        setEventList((prevList) => [...prevList, response.data]);
        return true;
      } else {
        setErrors(response?.errors || { general: "Failed to create Event." });
        return false;
      }
    } catch (error) {
      console.error("Error creating event : ", error);
      return false;
    }
  };

  const updateEvent = async (id, updatedDetails, setEventList, setErrors) => {
    try {
      const response = await updateEventRequest(id, updatedDetails);
      if (response?.success) {
        setEventList((prevList) =>
          prevList.map((item) => (item.id === id ? response.data : item))
        );
        return true;
      } else {
        setErrors(response?.errors || { general: "Failed to update event." });
        return false;
      }
    } catch (error) {
      console.error("Error updating event:", error);
      return false;
    }
  };

  const deleteEvent = async (id, EventList, setEventList) => {
    try {
      const response = await deleteEventRequest(id);
      if (response?.success) {
        const updatedList = EventList.filter((item) => item.id !== id);
        setEventList(updatedList);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return {
    createEvent,
    fetchAllEvents,
    fetchEventById,
    updateEvent,
    deleteEvent,
  };
};
